/**
 * Fraction Field Default Configuration
 *
 * Input field for fractional values (e.g., 3/4, 1/2).
 * Properties aligned with API JSON configuration structure.
 */

export interface FractionFieldConfig {
  label: string;
  showTitle: boolean;
  exclusionType: 'hide' | 'disable';
  displayName: string;
  shortDisplayName?: string;
  required: boolean;
  numerator: number;
  denominator: number;
}

export const FRACTION_DEFAULT_CONFIG: Omit<FractionFieldConfig, 'label' | 'displayName'> = {
  showTitle: true,
  exclusionType: 'hide',
  shortDisplayName: '',
  required: false,
  numerator: 0,
  denominator: 1,
};

/**
 * Create default configuration for a fraction field
 * @param fieldName The field name to use as label
 */
export const createFractionConfig = (fieldName: string): FractionFieldConfig => ({
  ...FRACTION_DEFAULT_CONFIG,
  label: fieldName,
  displayName: '',
});

export default createFractionConfig;
